(ns kc.interface
  #?(:cljs (:require-macros [kc.interface :refer [def-ui $ use-effect
                                                  use-layout-effect]]))
  (:require
   [helix.core :as helix]
   [helix.hooks :as helix-hooks]))

(defn log-format-objects? [macro-env]
  false)

#?(:cljs (def use-state helix-hooks/use-state)
   :clj (defn use-state [initial-value]
          (let [ATOM (atom initial-value)]
            [initial-value (fn [v] (reset! ATOM v))]))
   )

(defmacro use-effect [& body] `(helix-hooks/use-effect ~@body))

(defmacro use-layout-effect [& body] `(helix-hooks/use-layout-effect ~@body))

(defmacro $
  [component attrs children]
  (cond
    
    (= :<> component)
    `(helix/<> ~attrs ~@children)
    
    :else
    `(helix/$ ~component ~attrs ~@children)
    ))

(defmacro def-ui
  {:clj-kondo/lint-as 'clojure.core/defn}
  [component params-arg body opts fn-meta docstring]
  (let [
        debug? (-> opts :debug?)

        body (or (seq body)
                 (when true #_debug?
                       (list (str "<" component ">"))))

        ;; body (into [] body)
        ;; body (if debug?
        ;;        #_[(str "debug: " (into body ["boo"]))]
        ;;        (let [last-idx (dec (count body))]
        ;;          (assoc body last-idx
        ;;                 #_(get body last-idx)
        ;;                 `($ :div
        ;;                     {:style {:border "8px solid #600"}}
        ;;                     ($ :div
        ;;                        {:style {:background-color "#600"
        ;;                                 :padding 8}}
        ;;                        ($ :div
        ;;                           ~(str *ns* " / " component))
        ;;                        ;; ~@(for [p params]
        ;;                        ;;     ($ :div (str p "=")))
        ;;                        #_(str ~(reduce (fn [m [v k]]
        ;;                                          (assoc m ('quote (symbol (name k))) v))
        ;;                                        {} params-arg))
        ;;                        (>edn {} [~params-arg])
        ;;                        #_(>edn {} [~params-arg]))
        ;;                     ($ :div
        ;;                        ~(get body last-idx)))))

        ;;        body)

        ]

    `(helix.core/defnc ~component
       ~@(when docstring [docstring])
       ~@(when fn-meta [fn-meta])
       [~params-arg]
       ~opts
       ~@body
       )))

